/**
 * If you're looking to make a change to the session service, please edit `services/_private/session.ts`.
 *
 * This is a workaround to address nondeterministic builds as a result of converting SessionService to TypeScript.
 * Since the ember-simple-auth addon provides a version of its session service in its `app/services` directory,
 * it gets copied into garaje as build time. Depending on whether that happens before or after the TypeScript->JS
 * transpilation of the `session.ts` file in garaje, the app would end up either with the correct version (the TS one)
 * or the incorrect version (the one from ember-simple-auth).
 *
 * By providing a file at `app/services/session.js` we avoid getting the version copied from ember-simple-auth.
 *
 * For more information, see this issue: https://github.com/typed-ember/ember-cli-typescript/issues/780
 */

export { default } from 'garaje/services/_private/session';
export * from 'garaje/services/_private/session';
